import { orderBy } from 'lodash';
import { firstSelected } from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import { validityStatus } from '@/constants/states';
import { dataValidationFieldErrors } from './constants';

export const isInvalidTableError = (errors) => (
  errors.length === 1 && !dataValidationFieldErrors.includes(errors[0].type));

export const isInvalidFieldsError = (errors) => errors.length > 0 && dataValidationFieldErrors.includes(errors[0].type);

export const validationStatusIconProps = (valid) => {
  const props = {
    name: 'question circle',
    message: 'dataset.data.dictionary.validation.status.unknown',
    colour: null,
  };
  if (valid === true) {
    props.name = 'check circle';
    props.colour = 'green';
    props.message = 'dataset.data.dictionary.validation.status.valid';
  }
  if (valid === false) {
    props.name = 'warning circle';
    props.colour = 'red';
    props.message = 'dataset.data.dictionary.validation.status.invalid';
  }

  return props;
};

export const validationResultStatusIconProps = (status, dataExists) => {
  const props = {};
  if (status === validityStatus.VALID) {
    props.name = 'check circle';
    props.colour = 'green';
    props.message = 'dataset.dictionary.validation.valid.on.title';
  }
  if (status === validityStatus.INVALID) {
    props.name = 'warning circle';
    props.colour = 'red';
    props.message = 'dataset.dictionary.validation.invalid.on.title';
  }

  if (!dataExists || !status) {
    props.name = 'question circle';
    props.message = 'dataset.dictionary.validation.no.data.on.title';
    props.colour = null;
  }

  return props;
};

export const orderedDictionaries = (dictionaries) => orderBy(dictionaries, ['name'], ['asc']);

// If we do not have a selected validation dictionary then fetch the first ordered dictionary
export const selectedDictionaryCode = (dataset, datasetValidation = null) => {
  let [selectedDictionary] = orderedDictionaries(dataset.dictionaries);
  if (datasetValidation?.dictionaries) {
    selectedDictionary = firstSelected(datasetValidation.dictionaries) || selectedDictionary;
  }

  return selectedDictionary.code;
};

export const validationInProgress = (validationDataset) => validationDataset.readStatus === states.PENDING
  || !!(validationDataset?.dictionaries || []).find((d) => d.readStatus === states.PENDING);

export const validationServerErrors = (validationDataset) => (
  (validationDataset?.dictionaries || []).find((d) => d.readStatus === states.ERROR)?.readErrors
    || (validationDataset?.dictionaries || []).find((d) => d.saveStatus === states.ERROR)?.saveErrors
    || validationDataset?.saveErrors || validationDataset?.readErrors || []
);
